import { useTranslation } from "react-i18next";
import progressChart from "../../assets/images/RingNavInstruction.png";
import woodCut from "../../assets/images/Woodcut_xs.png";
import "./info-graph.scss";

export default function InfoGraph() {
  const { t } = useTranslation(["common"]);
  return (
    <div className="inphograph">
      <div className="ans-mock">
        <span>a)</span>
        <span className="checked">b)</span>
        <br />
        <span>c)</span>
        <b className="next"></b>
      </div>

      <div>
        <img
          src={progressChart}
          alt={t("footer.drink_responsibly")}
          className="img-responsive info-image"
        />
        <b className="next"></b>
      </div>
      <div>
        <img
          src={woodCut}
          alt={t("footer.drink_responsibly")}
          className="img-responsive info-image"
        />
      </div>
    </div>
  );
}
